<script lang="ts">
    import { _ } from "svelte-i18n"
    import { location } from "../../store"
    import Search from "../pagebuilder/blocks/Search.svelte"
    import ArticleSlider from "../pagebuilder/blocks/articleSlider/ArticleSlider.svelte"

    let count: number

    const search = $derived(decodeURIComponent($location.search?.substr(1)))
    const escapedSearch = $derived(search?.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"))
</script>

<section class="section-type-1">
    <div class="container-fluid">
        <div class="articles_header">
            <h3>
                {@html $_("search.search-for-html")}&nbsp;{search ? search : ""}
                {#if count}({$_("search.count-hits", {
                        values: { count: count ? count : 0 },
                    })}){/if}
            </h3>
        </div>
        <section class="search-section">
            <Search initialSearch={escapedSearch} />
        </section>
        <ArticleSlider
            articlesPreview={{
                direction: "vertical",
                sticky_header_title: $_("search.search-entries"),
                homepage_mode: false,
                article_types: "news, event, opinion, position",
                manual_selection: false,
            }}
            fullTextSearch={escapedSearch}
            fullWidth={true}
        />
    </div>
</section>

<style lang="less">
    @import "../../css/variables.less";
    .section-type-1 {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 0 1.2rem;
    }
    .container-fluid {
        max-width: var(--extended-max-width);
        width: 100%;
        padding: 0px;
        margin: 0px;
    }
    .search-section {
        margin: 2rem 0;
    }
    .articles_header {
        display: flex;
        justify-content: space-between;
    }
</style>
